import { BrandMark } from '@sentinel/web-core';
import type { ReactNode } from 'react';

/** The console page before its session exists: the mark and one line of what is happening. */
export function AuthFrame({ children }: { children: ReactNode }) {
  return (
    <main className="login">
      <div className="stack" style={{ alignItems: 'center', maxWidth: 420 }}>
        <BrandMark size={48} />
        {children}
      </div>
    </main>
  );
}
